import { Box, Grid, Typography } from "@mui/material";
import BookingFeeCard from "./BookingFeeCard";
import CODVisibilityCard from "./CODVisibilityCard";
import FullPaymentSetting from "./FullPaymentSetting";

const SettingsPayments = () => {
 return (
  <Box
   sx={{
    padding: "40px 30px",

    marginTop: "30px",
   }}
  >
   {/* Title Section */}
   <Box mb={5} sx={{ textAlign: "center" }}>
    <Typography variant="h4" color="primary" fontWeight="bold">
     Payment Settings
    </Typography>
    <Typography variant="body1" color="textSecondary">
     Configure your payment-related settings below.
    </Typography>
   </Box>

   {/* Main Grid for Layout */}
   <Grid container spacing={4} justifyContent="center">
    <Grid item xs={12} sm={6} md={4}>
     <BookingFeeCard />
    </Grid>
    <Grid item xs={12} sm={6} md={4}>
     <CODVisibilityCard />
    </Grid>
    <Grid item xs={12} sm={6} md={4}>
     <FullPaymentSetting />
    </Grid>
   </Grid>
  </Box>
 );
};

export default SettingsPayments;
